import { render, staticRenderFns } from "./ShortName.vue?vue&type=template&id=27c52080&"
import script from "./ShortName.vue?vue&type=script&lang=js&"
export * from "./ShortName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports